import React from 'react';
import { Nav } from 'react-bootstrap';
import { useForm } from 'react-final-form';
import styles from './RegistrationNavLink.module.scss';

interface IRegistrationNavLink {
  title: string;
  subTitle: string;
  step: number;
  disabled: boolean;
}

const RegistrationNavLink = (props: IRegistrationNavLink) => {
  const form = useForm();
  return (
    <Nav.Item className={styles.navItem}>
      <Nav.Link
        className={styles.navLink}
        eventKey={props.step}
        disabled={props.disabled}
        onClick={() => form.submit()}
      >
        <div className={styles.title}>{props.title}</div>
        <div className={styles.subtitle}>{props.subTitle}</div>
      </Nav.Link>
    </Nav.Item>
  );
};

export default RegistrationNavLink;
